// src/components/EmailVerification.js
import React, { useEffect, useState } from 'react';
import { Alert, Spinner, Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

const EmailVerification = () => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      if (!token) {
        setStatus('error');
        setMessage('Verification token is missing.');
        return;
      }

      try {
        const res = await fetch(`${API_URL}/public/api/v0/verify-email?token=${token}`);
        const result = await res.text(); // If you return plain message from backend
        if (res.ok) {
          setStatus('success');
          setMessage('Email verified successfully! Redirecting to login...');
          setTimeout(() => navigate('/login'), 3000);
        } else {
          setStatus('error');
          setMessage(result || 'Verification failed.');
        }
      } catch (err) {
        console.error(err);
        setStatus('error');
        setMessage('Something went wrong during verification.');
      }
    };

    verifyEmail();
  }, [API_URL, searchParams, navigate]);

  return (
    <Container className="mt-5 text-center">
      {status === 'loading' && <Spinner animation="border" />}
      {status === 'success' && <Alert variant="success">{message}</Alert>}
      {status === 'error' && <Alert variant="danger">{message}</Alert>}
    </Container>
  );
};

export default EmailVerification;
